import {
  Card,
  Column,
  Icon,
  IconButton,
  Row,
  SubtitleText,
  Title,
} from "@/shared/ui";
import React from "react";
import { Reference } from "./ReferencesContext";
import { useTranslation } from "react-i18next";
import { IconName } from "@/images/icons/types";
import { ReferenceCard } from "../ReferenceCard";
import { AnyParsedTag } from "@/lib/dimension-tag-parser";

interface ReferencesDrawerProps {
  references?: Reference[];
  data?: any;
  onClose?: () => void;
}

const getIconForType = (type?: string): IconName => {
  switch (type) {
    case "DIMENSION":
    case "DIMENSION_HIGHLIGHT":
      return "Big5";
    case "PERSON":
      return "User";
    case "FILE":
      return "File";
    case "ASSESSMENT_REPORT":
      return "AssessmentReport";
    case "ASSESSMENT_PSYCH":
      return "SurveyQuestion";
    case "PROJECT_DESCRIPTION":
      return "Projects";
    default:
      return "Link";
  }
};

const getIdLabel = (ref: Reference): string => {
  if (ref.dim_id) return `DIMENSION:${ref.dim_id}`;
  if (ref.person_id) return `PERSON:${ref.person_id}`;
  if (ref.file_id) return `FILE:${ref.file_id}`;
  return ref.type || "Reference";
};

export const ReferencesDrawer = (props: ReferencesDrawerProps) => {
  const { references, data, onClose } = props;
  const { t } = useTranslation();

  if (!references || references?.length === 0) {
    return null;
  }

  const referencesCount = references.length;

  return (
    <Card className="h-full overflow-auto rounded-r-none">
      <Row className="items-center justify-between p-4 border-b border-grey-200">
        <Row className="items-center gap-4">
          <Title as="h5">{t("common.sources")}</Title>•
          <SubtitleText className="leading-[unset]">
            {referencesCount}
          </SubtitleText>
        </Row>
        <IconButton
          icon="Close"
          variant="ghost"
          color="black"
          onClick={onClose}
        />
      </Row>
      <Column className="p-4 gap-4">
        {references.map((ref, index) => (
          <ReferenceCard
            key={ref?.id || `index-${index}-${ref?.type}`}
            reference={ref as AnyParsedTag}
            data={data}
          />
        ))}
      </Column>
    </Card>
  );
};
